module.exports = __webpack_public_path__ + "img/desktop2.f00f1126.png";